import Environment from '../../../Environment';
import BaseService, { IHttpResponse, buildUrl } from '../../BaseService';

const RESOURCE = 'headcounts';

interface IEmbeddedHeadcount {
  event: { id: string };
  session?: { id: string };
  'repeating-event'?: { id: string };
}

interface ICreateHeadcountRequest {
  token: string;
  app_key: string;
  count: number;
  _embedded: IEmbeddedHeadcount;
}

interface ICreateHeadcountResponse extends IHttpResponse {
  body?: {
    org_key: string;
    id: string;
    app_key: string;
    count: number;
    _embedded: IEmbeddedHeadcount;
  };
}

export default async ({
  token,
  app_key,
  count,
  _embedded,
}: ICreateHeadcountRequest): Promise<ICreateHeadcountResponse> => {
  const url = buildUrl({
    host: Environment.groupsHost,
    resource: RESOURCE,
  });

  return BaseService.Post({
    url,
    token: token,
    data: {
      app_key,
      count,
      _embedded,
    },
  });
};
